import {
  commonMutationTypes,
  commonPaginationTypes,
  OrderDirection,
  pageInfo,
  userDetails,
} from "../../../../../../utils/commonQueryTypes";
import { concludeFormDataType } from "../../../../../../utils/formTypes";
import { AtsStckItem } from "../../../masters/items/queries/types";
import { AtsSubsidiary } from "../../../masters/subsidary/queries/types";

export enum MrfTrnQueryType {
  ALL_ITEMS = "ALL_ITEMS",
  PENDING_ITEMS = "PENDING_ITEMS",
  APPROVED_ITEMS = "APPROVED_ITEMS",
  REJECTED_ITEMS = "REJECTED_ITEMS",
}

export enum AtsMrfMstOrderField {
  CREATED_AT = "CREATED_AT",
  MRF_NO = "MRF_NO",
  MRF_DATE = "MRF_DATE",
  START_DATE = "START_DATE",
  CLOSE_DATE = "CLOSE_DATE",
  ACCEPT_START_DATE = "ACCEPT_START_DATE",
  ACCEPT_CLOSE_DATE = "ACCEPT_CLOSE_DATE",
}

export enum AtsMrfTrnOrderField {
  CREATED_AT = "CREATED_AT",
  SL_NO = "SL_NO",
  TRN_DATE = "TRN_DATE",
  TRN_NEED_BEFORE = "TRN_NEED_BEFORE",
}

export enum MrfQueryType {
  ALL_MRFS = "ALL_MRFS",
  DRAFT_MRFS = "DRAFT_MRFS",
  PENDING_MRFS = "PENDING_MRFS",
  IN_PROGRESS_MRFS = "IN_PROGRESS_MRFS",
  APPROVED_MRFS = "APPROVED_MRFS",
  REJECTED_MRFS = "REJECTED_MRFS",
}

export interface CreateMrfItemList {
  itemId: number;
  slNo: string;
  uom: string;
  udfItemDesc: string;
  presentStk: number;
  reqQty: number;
  approxRate: number;
  taxable: number;
  tax: number;
  priority: string;
  trnNeedBefore: string;
  preferedSupplierIds: string;
  usedFor: string;
  remarks: string;
}
export interface CreateMrf {
  mrfDate: string;
  refNo: string;
  remarks: string;
  docPath: string;
  subsidiaryID: number;
  itemsList: CreateMrfItemList[];
}
export interface AddMrfVars extends commonMutationTypes {
  customerId: number;
  input: CreateMrf;
  finYrId: number;
}

export interface AddMrfResult {
  AddMrf: boolean;
}

export interface GetMrfsVars extends commonPaginationTypes {
  finYrId: number;
  customerId: number;
  name: string;
  queryType: MrfQueryType;
  start_date: string;
  end_date: string;
  orderBy: {
    direction: OrderDirection;
    field: AtsMrfMstOrderField;
  };
}

export interface AtsMrfMst {
  id: number;
  mrfNo: string;
  mrfDate: string;
  refNo: string;
  acceptStatus: string;
  remarks: string;
  subsidiary: AtsSubsidiary;
  rfqPendingItems: AtsMrfTrn[];
  rfqCompletedItems: AtsMrfTrn[];
  raisedByUserDetails: {
    id: number;
    name: string;
  };
  itemQty: number;
  totalQty: number;
}
export interface AtsMrfMstEdge {
  node: AtsMrfMst;
  cursor: string;
}

export interface GetMrfsData {
  edges: AtsMrfMstEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}

export interface GetMrfsResult {
  GetMrfs: GetMrfsData;
}

export interface GetMrfTrnsVars extends commonPaginationTypes {
  customerId: number;
  name: string;
  finYrId: number;
  mrfId: number;
  queryType: MrfTrnQueryType;
  orderBy: {
    direction: OrderDirection;
    field: AtsMrfTrnOrderField;
  };
}

export interface AtsMrfTrn {
  id: number;
  itemID: number;
  uom: string;
  udfItemDesc: string;
  presentStk: number;
  reqQty: number;
  approxRate: number;
  taxable: number;
  tax: number;
  approxValue: number;
  acceptStatus: string;
  acceptRemarks: string;
  priority: string;
  trnNeedBefore: string;
  preferedSupplierIds: string;
  usedFor: string;
  remarks: string;
  mrf: AtsMrfMst;
  item: AtsStckItem;
  acceptQty: string;
  acceptRate: string;
  approxDlvryRate: number;
  approxInstRate: number;
  approxOtherRate: number;
  preferedSupplierDetails: {
    id: number;
    desc: string;
  }[];
}

export interface AtsMrfTrnEdge {
  node: AtsMrfTrn;
  cursor: string;
}
export interface GetMrfTrnsData {
  edges: AtsMrfTrnEdge[];
  pageInfo: pageInfo;
  totalCount: number;
}
export interface GetMrfTrnsResult {
  GetMrfTrns: GetMrfTrnsData;
}

export interface DeleteDraftMrfResult {
  DeleteDraftMrf: boolean;
}

export interface DeleteDraftMrfVars extends commonMutationTypes {
  customerId: number;
  finYrId: number;
  mrfId: number;
}

export interface AtsMrfTrn {
  id: number;
  slNo: number;
  udfItemDesc: string;
  uom: string;
  acceptQty: string;
  acceptRate: string;
  approxOtherRate: number;
  approxInstRate: number;
  approxDlvryRate: number;
  presentStk: number;
  reqQty: number;
  approxRate: number;
  taxable: number;
  tax: number;
  priority: string;
  trnNeedBefore: string;
  remarks: string;
  mrf: AtsMrfMst;
  preferedSupplierDetails: {
    id: number;
    desc: string;
  }[];
  item: AtsStckItem;
}

interface UpdateMrfItemList extends concludeFormDataType {
  mrfTrnId: number;
  preferedSupplierIds: string;
}
export interface UpdateItemInMrfTrnVars {
  token?: string;
  customerId: number;
  finYrId: number;
  mrfId: number;
  user_details: userDetails;
  input: UpdateMrfItemList[];
  trnDate: string;
}

export interface UpdateItemInMrfTrnResult {
  UpdateItemInMrfTrn: boolean;
}
export interface UpdateDraftMrfResult {
  UpdateDraftMrf: boolean;
}

export interface UpdateMrf {
  mrfDate: String;
  refNo: String;
  remarks: String;
  docPath: String;
  subsidiaryID: number;
  itemsList: CreateMrfItemList[];
}

export interface UpdateDraftMrfVars extends commonMutationTypes {
  customerId: number;
  finYrId: number;
  mrfId: number;
  input: UpdateMrf;
}

export interface ApproveOrRejectMrfResult {
  ApproveOrRejectMrf: boolean;
}

export interface ApproveOrRejectMrfVars {
  token?: string;
  customerId: number;
  finYrId: number;
  mrfId: number;
  user_details: userDetails;
  input: {
    acceptQty: number;
    acceptTaxable: number;
    acceptTax: number;
    acceptValue: number;
    acceptStatus: string;
    acceptRemarks: string;
  };
  todaysDate: string;
}
